import React from 'react';
import OrderContainer from '../../../redux/containers/OrderContainer';
import SummaryContainer from '../../../redux/containers/SummaryContainer';

const CreditAssessmentStep4 = () =>
  <section>
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <h3 className="half-charcoal">Summary</h3>
        </div>
      </div>
    </div>
    <SummaryContainer />
    <OrderContainer />
  </section>
;

export default CreditAssessmentStep4;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/CreditAssessmentStep4/CreditAssessmentStep4.js
 **/